import { useEffect } from "react";
import { useGetAllCms, useGetMembersData } from "../../helpers/api/cmsApi";
import useCommonGlobalStore, { commonZustandGlobalSelector, shallow } from "../../helpers/store/common.store";
import { useSocket } from "../socket/SocketProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetProfile } from "../../views/Inner/api/innerApi";
import { decodeJWT, swiperTab } from "../common/commonMethods";

const AGENT_HEADINGS = ["edison", "atlas", "shaka", "sensei", "lilith", "pythagoras"]


const AppBooster = ({ children }) => {
  const token = localStorage.getItem('token')
  const { data, isSuccess, isLoading } = useGetAllCms();
  const { data: membersData, isSuccess: memeberSuccess } = useGetMembersData(token)
  const { data: p_data, isSuccess: p_success } = useGetProfile();
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { CommonSocket } = useSocket();
  const setCommonZustGlobalState = useCommonGlobalStore(
    (s) => s.setCommonZustGlobalState
  );
  const { authToken } = useCommonGlobalStore(
    commonZustandGlobalSelector,
    shallow,
  );

  const handleHomeContent = (acc, item) => {
    const { heading } = item;

    if (heading === "aboutus") {
      acc.home.aboutus = item;
    } else if (AGENT_HEADINGS.includes(heading)) {
      acc.home.agents[heading] = item;
    } else if (heading === "application_top_content") {
      acc.home.application.top = item;
    } else if (heading.startsWith("application_box")) {
      acc.home.application.boxes.push(item);
    } else if (heading === "application_bottom_content") {
      acc.home.application.bottom = item;
    } else if (heading === "network_content") {
      acc.home.network.main = item;
    } else if (heading.startsWith("network_popup")) {
      acc.home.network.popup.push(item);
    } else if (heading === "alert_top_content") {
      acc.home.alert.top = item;
    } else if (heading === "alert_robot_content") {
      acc.home.alert.robot = item;
    }
  }

  useEffect(() => {
    const updatedState = {
      cmsLoading: isLoading,
    };
    if (isSuccess && data) {
      const c_data = data?.data || []
      const cmsData = () => {
        const initialState = {
          agent: {},
          roadmap: [],
          home: {
            aboutus: null,
            agents: {},
            application: {
              top: null,
              boxes: [],
              bottom: null,
            },
            network: {
              main: null,
              popup: [],
            },
            alert: {
              top: null,
              robot: null,
            },
          },
        };

        if (!c_data?.length) return initialState;

        return c_data.reduce((acc, item) => {
          const { sub_type, heading } = item;

          switch (sub_type) {
            case "agent":
              acc.agent[heading] = item;
              break;

            case "roadmap":
              acc.roadmap.push(item);
              break;

            case "home":
              handleHomeContent(acc, item);
              break;

            default:
              break;
          }

          return acc;
        }, initialState);
      }

      updatedState.cmsAllData = data?.data;
      updatedState.cmsData = cmsData();

      const edison_s = data?.agent_list?.find((d) => d.agent_name === "edison")
      updatedState.edisonStatus = edison_s?.status
    }
    setCommonZustGlobalState(updatedState);
  }, [isLoading, isSuccess, data, setCommonZustGlobalState]);

  useEffect(() => {
    if (!authToken && token) {
      const jwt_token_decode = decodeJWT(token)
      setCommonZustGlobalState({ authToken: token, authUserId: jwt_token_decode.payload.user_id })
    }
  }, [authToken, setCommonZustGlobalState, token])

  useEffect(() => {

    if (!CommonSocket || !authToken) return;

    const joinRoom = () => {
      CommonSocket.emit("join_user", { token: `Bearer ${authToken}` });
    };

    if (CommonSocket?.connected) {
      joinRoom();
    } else {
      CommonSocket.once("connect", joinRoom);
    }

    return () => {
      CommonSocket.off("connect", joinRoom);
      CommonSocket.off("join_user");
    };
  }, [CommonSocket, CommonSocket?.connected, authToken]);

  useEffect(() => {
    if (pathname === "/support") {
      const updateData = {
        type: 'support',
        slideTo: swiperTab.EDISON,
      };
      navigate("/");
      setCommonZustGlobalState({
        swiperData: updateData
      })
    }
  }, [navigate, pathname, setCommonZustGlobalState])

  useEffect(() => {
    if (memeberSuccess && membersData) {
      setCommonZustGlobalState({ memberData: membersData?.data })
    }
  }, [membersData, memeberSuccess, setCommonZustGlobalState])

  useEffect(() => {
    if (p_success && p_data) {
      setCommonZustGlobalState({ profileData: p_data?.data })
    }
  }, [p_data, p_success, setCommonZustGlobalState])


  return children;
};

export default AppBooster;
